import * as React from 'react';
function useCurrentBreakPoint(breakPoints) {
    const [breakPoint, setBreakPoint] = React.useState(null);
    React.useEffect(() => {
        const resizeListener = () => {
            const sortedBreakPoints = Object.keys(breakPoints).sort((x, y) => breakPoints[y] - breakPoints[x]);
            const bp = sortedBreakPoints.find((breakPoint) => window.matchMedia(`(min-width: ${breakPoints[breakPoint]}px)`).matches);
            setBreakPoint(bp || 'xs');
        };
        window.addEventListener('resize', resizeListener);
        resizeListener();
        return () => {
            window.removeEventListener('resize', resizeListener);
        };
    }, [breakPoints]);
    return breakPoint;
}
function useResponsiveProps(props) {
    const { responsive, breakPoints } = props;
    const responsiveBreakPoints = responsive.map((resp) => resp.breakPoint);
    const currentBreakPoint = useCurrentBreakPoint(breakPoints);
    const getActiveBreakPoints = (currentBreakPoint, responsiveBP) => {
        const sortedResponsiveBreakPoints = (responsiveBP).sort((x, y) => breakPoints[x] - breakPoints[y]);
        return sortedResponsiveBreakPoints.filter((breakPoint) => {
            return breakPoints[breakPoint] <= breakPoints[currentBreakPoint];
        });
    };
    const getResponsiveProps = (breakPoint) => {
        const responsiveObject = responsive.find((resp) => resp.breakPoint === breakPoint) || undefined;
        return responsiveObject ? responsiveObject.props : undefined;
    };
    if (!currentBreakPoint) {
        return {};
    }
    const activeBreakPoints = getActiveBreakPoints(currentBreakPoint, responsiveBreakPoints);
    return activeBreakPoints.reduce((acc, breakPoint) => (Object.assign(Object.assign({}, acc), getResponsiveProps(breakPoint))), {});
}
export { useCurrentBreakPoint, useResponsiveProps, };
